// extracted by mini-css-extract-plugin
export default {"container":"container_J6iNH","isWebView":"isWebView_rmOUE"};